import FormAnswerYesNoChoices from './FormAnswerYesNoChoices';
import { FormAnswerYesNoChoicesProps } from './type';

export default FormAnswerYesNoChoices;
export type { FormAnswerYesNoChoicesProps };
